// extracted by css-extract-rspack-plugin
export default {"checkbox":"g8OaJB","align-items-center":"JFTARO","alignItemsCenter":"JFTARO","label":"CZpDc_"};